import React, { useState } from "react";
import Lowarrow from "../../../asset/images/low-arrow.svg";
import UpArrow from "../../../asset/images/up-arrow.svg";
import { Constants } from "../../../CommonMethhods/Constants";
import {
  forToFix,
  numDifferentiationWithoutSymbol,
} from "../../../CommonMethhods/CovertRupees";
import SmallLoader from "../../Common/smallLoader";
import { Form } from "react-bootstrap";
import { truncate } from "../../../CommonMethhods/CommonMethods";
import Loader from "../../Common/Loader";

function SalesSnapshot(props) {
  const revenueTable = props.revenueTableData;
  // const yesterday = revenueTable.yesterday;
  // const weekly = revenueTable.weekly;
  // const month = revenueTable.monthly;
  // const year = revenueTable.yearly;
  const setShowTurnoverModal = props?.setShowTurnoverModal
  // const [modalDuration, setModalDuration] = useState("Yesterday");
  const salesLoader = props.salesLoader;
  const salesModalDuration = props?.salesModalDuration
  const setSalesModalDuration = props?.setSalesModalDuration  

  const rowLabels = ["Equity", "Futures", "Options", "Total"];
  const handleifTableEmpty = (flag) => {
    const tempArray = [
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
    ];

    return tempArray.map((column, index) => {
      return (
        <tr key={index} className="snapshot-table-row snapshot-body">
          {flag === true ? (
            <th className="text-left header-width first-col tooltip-manage">{rowLabels[index]}
            {rowLabels[index] === "Options" && 
                        <div className="tooltip123">
                          {truncate(<span className="icon-info-icon"></span>)}
                        <span className="tooltiptext snapshot-tooltip">Sales for Options is in Lots</span>
                        </div>
                        }
            </th>
           ) : (
            <></>
          )} 
          {column.map((index) => {
            return (
              <td key={index} className="snapshot-table-columns">
                {"0"}
              </td>
            );
          })}
        </tr>
      );
    });
  };

  const generateOverallTableData = (rows, flag) => {
    return Object.keys(rows).map((column, index) => {
      const columnValues = rows[column];
      rows[column].revenue = rows[column].revenue || 0;
      rows[column].saleExist = rows[column].saleExist || 0;
      rows[column].chg = rows[column].chg || 0;
      rows[column].chgper = forToFix(rows[column].chgper) || 0;      

      // rows[column].chgper=  rows[column].chgper.toFixed(2) || (rows[column].chgper).toFixed(2) ;

      return (
        <tr key={index} className="snapshot-table-row snapshot-body">
          {/* {flag == true ? ( */}
            <th className="text-left header-width first-col tooltip-manage"> {rowLabels[index]}
              {rowLabels[index] === "Options" && 
                        <div className="tooltip123">
                          {truncate(<span className="icon-info-icon"></span>)}
                        <span className="tooltiptext snapshot-tooltip">Sales for Options is in Lots</span>
                        </div>
                        }

            </th>
          {/* ) : (
            <></>
          )} */}
          <td key={index} className="snapshot-table-column overall-aum-new">
            <>
              {/* <img
                src={
                  columnValues.chg === 0
                    ? ""
                    : columnValues.chg < 0
                    ? Lowarrow
                    : UpArrow
                }
                alt=""
              /> */}
              <>
                {columnValues.sale == undefined || null
                  ? "0"
                  : numDifferentiationWithoutSymbol(columnValues.sale, 1)}
              </>
            </>
          </td>
          <td className="snapshot-table-column">
            <span
              className={
                columnValues.saleExist == 0
                  ? "text-muted"
                  : columnValues.saleExist < 0
                  ? "red-new-txt"
                  : "green-new-text"
              }
            >
              {columnValues.saleExist == undefined || null
                ? "0"
                : numDifferentiationWithoutSymbol(columnValues.saleExist)}
            </span>
          </td>
          <td className="snapshot-table-column">
            <span
              className={
                columnValues.chg == 0
                  ? "text-muted"
                  : columnValues.chg < 0
                  ? "red-new-txt"
                  : "green-new-text"
              }
            >
              {columnValues.chg == undefined || null
                ? "0"
                : numDifferentiationWithoutSymbol(columnValues.chg)}
            </span>
          </td>
          <td className="snapshot-table-column">
            <span
              className={
                columnValues.chgper == 0
                  ? "text-muted"
                  : columnValues.chgper < 0
                  ? "red-new-txt"
                  : "green-new-text"
              }
            >
              {columnValues.chgper == undefined || null
                ? "0"
                : columnValues.chgper}{" "}
              %
            </span>
          </td>
        </tr>
      );
    });
  };

  //handle data
  const generateSnapshotTableData = (rows, flag) => {
    return Object.keys(rows).map((column, index) => {
      const columnValues = rows[column];
      rows[column].revenue = rows[column].sale || 0;
      rows[column].saleExist = rows[column].saleExist || 0;
      rows[column].chg = rows[column].chg || 0;
      rows[column].chgper = forToFix(rows[column].chgper) || 0;

      // rows[column].chgper=  rows[column].chgper.toFixed(2) || (rows[column].chgper).toFixed(2) ;

      return (
        <tr key={index} className="snapshot-table-row snapshot-body">
          {/* {flag === true ? ( */}
            <th className="text-left header-width first-col tooltip-manage"> {rowLabels[index]}
              {rowLabels[index] === "Options" && 
                        <div className="tooltip123">
                          {truncate(<span className="icon-info-icon"></span>)}
                        <span className="tooltiptext snapshot-tooltip">Sales for Options is in Lots</span>
                        </div>
                        }
            </th>
          {/* ) : (
            <></>
          )} */}

          <td className="snapshot-table-column overall-aum-new">
            <>
              <img
                src={
                  columnValues.chg === 0
                    ? ""
                    : columnValues.chg < 0
                    ? Lowarrow
                    : UpArrow
                }
                alt=""
              />
              <>
                {/* <a
                  className="overall-revenue"
                  onClick={() => handleViewClick(column, "Overall")}
                > */}
                {columnValues.sale === undefined || null
                  ? "0"
                  : numDifferentiationWithoutSymbol(columnValues.sale)}
                {/* </a> */}
              </>
            </>
          </td>
          <td className="snapshot-table-column">
            <span
              className={
                columnValues.saleExist === 0
                  ? "text-muted"
                  : columnValues.saleExist < 0
                  ? "red-new-txt"
                  : "green-new-text"
              }
            >
              {columnValues.saleExist === undefined || null
                ? "0"
                : numDifferentiationWithoutSymbol(columnValues.saleExist)}
            </span>
          </td>
          <td className="snapshot-table-column">
            <span
              className={
                columnValues.chg === 0
                  ? "text-muted"
                  : columnValues.chg < 0
                  ? "red-new-txt"
                  : "green-new-text"
              }
            >
              {columnValues.chg === undefined || null
                ? "0"
                : numDifferentiationWithoutSymbol(columnValues.chg)}
            </span>
          </td>
          {/* <br /> */}
          <td className="snapshot-table-column">
            <span
              className={
                columnValues.chgper === 0
                  ? "text-muted"
                  : columnValues.chgper < 0
                  ? "red-new-txt"
                  : "green-new-text"
              }
            >
              {columnValues.chgper === undefined || null
                ? "0"
                : columnValues.chgper}{" "}
              %
            </span>
          </td>
        </tr>
      );
    });
  };

  const handleFileType = (e) => {
    if (e.target.value) {
      props.handleOnClickSnapFileType(e.target.value, "Sales");
    }
  };

  const handleSnapshotDuration = (e)=> {
    setSalesModalDuration(e?.target?.value)
  }

  return (
    <div className="snapshot-detail-block revenue-detail aum-report">
      <div className="card-title mb-0 aum-title">
        <span>{props.title}</span>

        <div className="wrap-modal-header">
                   <div className="filter-options">
                      {/* <!-- dropdown --> */}
                      <div className="new-dropdown">
                        <Form.Select
                          size="lg"
                          aria-label="Default select example"
                          onChange={(e)=>handleSnapshotDuration(e)}
                        >
                          <option value="Yesterday">{Constants.Yesterday}</option>
                          <option value="Weekly">{Constants.Current_Week}</option>
                          <option value="Monthly">{Constants.Current_Month}</option>
                          <option value="Yearly">{Constants.Current_Year}</option>
        
                          {/* <option value="Overall">Overall</option> */}
                        </Form.Select>
                      </div>
                    </div>
                <div className="generate-btn-wrapper mt-0">
                  <button
                    className="generate-btn excel1 text-green new-excel-btn"
                    value="excel"
                    onClick={(e) => handleFileType(e)}
                  >
                    {props?.buttonLoader?.excel ? (
                      <SmallLoader />
                    ) : (
                      <>
                        <span className="icon-excelsvg"></span>
                        Excel
                      </>
                    )}
                  </button>
                  <button
                    className="generate-btn pdf1 txt-purple new-pdf-btn"
                    value="pdf"
                    onClick={(e) => handleFileType(e)}
                  >
                    {props?.buttonLoader?.pdf ? (
                      <SmallLoader />
                    ) : (
                      <>
                        <span className="icon-pdfsvg"></span> PDF
                      </>
                    )}
                  </button>
                </div>

                <button
            type="button"
            className="btn-close snapshot-close-btn"
            aria-label="Close"
            onClick={()=> setShowTurnoverModal(false)}
          >
            <span className="icon-close"></span>
          </button>
        </div>
      </div>

      <div className="snapshot-table scroll-table snapshot-new-table">
        <table className="table tabel-level1">
          <tr>
            {salesModalDuration === "Yesterday" ?
            <>
             <div>
                <th
                  colSpan="3"
                  scope="col"
                  className="col-width-tab duration-title"
                >
                  {Constants.Yesterday}
                  <span> {Constants.Compare_Yesterday}</span>
                </th>
              </div>
            <td className="for-width pb-0">
              <table className="table table-level2">
                {salesLoader === true ? <div className="loader-alignment">
                <Loader />
              </div>
              : <>
                <thead>
                  <tr className="snapshot-head">
                    <th
                      colSpan="3"
                      scope="col"
                      className="col-width-tab text-center snapshot-title"
                    >
                      {/* {Constants.Yesterday} */}
                      Segment

                      {/* <br />
                      <span>{Constants.Compare_Yesterday}</span> */}
                    </th>
                    <th scope="col">Sales</th>
                    <th scope="col">{Constants.Previous}</th>
                    <th scope="col">{Constants.Change}</th>
                    <th scope="col">{Constants.Change_Perc}</th>
                  </tr>
                </thead>
                <tbody>
                  {revenueTable == null || undefined
                    ? handleifTableEmpty(true)
                    : generateOverallTableData(revenueTable, true)}
                </tbody>
                </>
              }
              </table>
            </td>
            </>
            : salesModalDuration === "Weekly" ?
            <>
            <div>
                <th
                  colSpan="3"
                  scope="col"
                  className="col-width-tab duration-title"
                >
                  {Constants.Current_Week}
                  <span> {Constants.Compare_Week}</span>
                </th>
              </div>
            <td className="for-width pb-0">
              <table className="table table-level2">
                {salesLoader === true ? <div className="loader-alignment">
                <Loader />
              </div>
              : 
              <>
                <thead>
                  <tr className="snapshot-head">
                    <th
                      colSpan="3"
                      scope="col"
                      className="col-width-tab text-center snapshot-title"
                    >
                      Segment
                      {/* {Constants.Current_Week}
                      <br />
                      <span>{Constants.Compare_Week}</span> */}
                    </th>
                    <th scope="col">Sales</th>
                    <th scope="col">{Constants.Previous}</th>
                    <th scope="col">{Constants.Change}</th>
                    <th scope="col">{Constants.Change_Perc}</th>
                  </tr>
                </thead>
                <tbody>
                  {revenueTable == null || undefined
                    ? handleifTableEmpty(true)
                    : generateSnapshotTableData(revenueTable, "Weekly")}
                </tbody>
                </>
              }
              </table>
            </td>
            </>
            : salesModalDuration === "Monthly" ?
            <>
            <div>
                <th
                  colSpan="3"
                  scope="col"
                  className="col-width-tab duration-title"
                >
                  {Constants.Current_Month}
                  <span> {Constants.Compare_Month}</span>
                </th>
              </div>
            <td className="for-width pb-0">
              <table className="table table-level2">
                {salesLoader === true ? <div className="loader-alignment">
                <Loader />
              </div>
              : 
              <>
                <thead>
                  <tr className="snapshot-head">
                    <th
                      colSpan="3"
                      scope="col"
                      className="col-width-tab text-center snapshot-title"
                    >
                      Segment
                      {/* {Constants.Current_Month}
                      <br />
                      <span>{Constants.Compare_Month}</span> */}
                    </th>
                    <th scope="col">Sales</th>
                    <th scope="col">{Constants.Previous}</th>
                    <th scope="col">{Constants.Change}</th>
                    <th scope="col">{Constants.Change_Perc}</th>
                  </tr>
                </thead>
                <tbody>
                  {revenueTable == null || undefined
                    ? handleifTableEmpty(true)
                    : generateSnapshotTableData(revenueTable, "Monthly")}
                </tbody>
                </>
              }
              </table>
            </td>
            </>
            :
            <>
            <div>
                <th
                  colSpan="3"
                  scope="col"
                  className="col-width-tab duration-title"
                >
                  {Constants.Current_Year}
                  <span> {Constants.Compare_Year}</span>
                </th>
              </div>
            <td className="for-width pb-0">
              <table className="table table-level2">
                {salesLoader === true ? <div className="loader-alignment">
                <Loader />
              </div>
              : 
              <>
                <thead>
                  <tr className="snapshot-head">
                    <th
                      colSpan="3"
                      scope="col"
                      className="col-width-tab text-center snapshot-title"
                    >
                      Segment
                      {/* {Constants.Current_Year}
                      <br />
                      <span>{Constants.Compare_Year}</span> */}
                    </th>
                    <th scope="col">Sales</th>
                    <th scope="col">{Constants.Previous}</th>
                    <th scope="col">{Constants.Change}</th>
                    <th scope="col">{Constants.Change_Perc}</th>
                  </tr>
                  
                </thead>
                <tbody>
                  {revenueTable == null || undefined
                    ? handleifTableEmpty(true)
                    : generateSnapshotTableData(revenueTable, "Yearly")}
                </tbody>
              </>
              }
              </table>
            </td>
            </>
          }
          </tr>
        </table>
      </div>
    </div>

    
  );
}

export default React.memo(SalesSnapshot);
